import { render, staticRenderFns } from "./up-flow-dialog.vue?vue&type=template&id=1e938aba&scoped=true&"
import script from "./up-flow-dialog.vue?vue&type=script&lang=js&"
export * from "./up-flow-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e938aba",
  null
  
)

export default component.exports